function toDateOnly(value) {
  if (value instanceof Date) {
    return new Date(value.getFullYear(), value.getMonth(), value.getDate());
  }

  if (typeof value === 'string') {
    const [year, month, day] = value.split('-').map(Number);
    if ([year, month, day].every(Number.isInteger)) {
      const parsed = new Date(year, month - 1, day);
      if (
        parsed.getFullYear() === year &&
        parsed.getMonth() === month - 1 &&
        parsed.getDate() === day
      ) {
        return parsed;
      }
    }

    const parsed = new Date(value);
    if (!Number.isNaN(parsed.getTime())) {
      return toDateOnly(parsed);
    }
  }

  return toDateOnly(new Date());
}

function parseDateInput(value) {
  if (!value || typeof value !== 'string') return null;

  const [year, month, day] = value.split('-').map(Number);
  if (![year, month, day].every(Number.isInteger)) return null;

  const parsed = new Date(year, month - 1, day);
  if (
    parsed.getFullYear() !== year ||
    parsed.getMonth() !== month - 1 ||
    parsed.getDate() !== day
  ) {
    return null;
  }

  return parsed;
}

function addDays(date, days) {
  const result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  result.setDate(result.getDate() + days);
  return result;
}

export function formatDateInput(value) {
  const date = toDateOnly(value);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function getChatFullLogsInitialDateFilters() {
  return { startDate: '', endDate: '' };
}

export function resolveChatFullLogsDateRange({ startDate = '', endDate = '', today = new Date() } = {}) {
  const todayInput = formatDateInput(today);

  if (!startDate && !endDate) {
    return { startDate: todayInput, endDate: todayInput };
  }

  if (startDate && !endDate) {
    const parsedStartDate = parseDateInput(startDate);
    if (!parsedStartDate) return { startDate, endDate };

    const calculatedEndDate = formatDateInput(addDays(parsedStartDate, 60));
    return {
      startDate,
      endDate: calculatedEndDate > todayInput ? todayInput : calculatedEndDate,
    };
  }

  if (!startDate && endDate) {
    const parsedEndDate = parseDateInput(endDate);
    if (!parsedEndDate) return { startDate, endDate };

    return {
      startDate: formatDateInput(addDays(parsedEndDate, -60)),
      endDate,
    };
  }

  return { startDate, endDate };
}

export function resolveChatFullLogsDatePickerValues(filters = {}) {
  return resolveChatFullLogsDateRange(filters);
}

export function shouldSearchChatFullLogsOnTableOptions({ hasSearched = false } = {}) {
  return hasSearched;
}
